import script from "./ModulePagination.vue?vue&type=script&setup=true&lang=js"
export * from "./ModulePagination.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__